import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { Unit } from 'src/features/units/utils/types';
import { UnitFormSchemaValues } from 'src/features/units/utils/formSchema';

const RESOURCE = '/financial-documents/unit/:unitId/';

type MutationFnType = typeof mutationFn;

interface DTO extends UnitFormSchemaValues {
    unitId: string;
}
const mutationFn = ({ unitId, ...data }: DTO): Promise<Unit> => {
    return axios.put(formatResourcePath(RESOURCE, { unitId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateUnit };
